module.exports = [{
      plugin: require('/opt/www/Gatsby_jbelknap.me/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
